import React from "react";
import Modal from "../modal";
import BlocksComponent from "./learn-more/BlocksComponent";
import LearnMoreHeader from "./learn-more/LearnMoreHeader";
import OverviewComponent from "./learn-more/OverviewComponent";
import ToggleComponent from "./learn-more/ToggleComponent";
import { RillContext } from "../../rill/RillReact/share/base";

class LearnMoreModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tabIndex: 0,
    };
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  handleTabChange(tabIndex) {
    this.setState({ tabIndex });
  }

  render() {
    const {
      locals: { athlete, editCycle, programExercises },
    } = this.context;
    const { tabIndex } = this.state;
    const { fromAthlete } = this.props;

    return (
      <Modal
        canClose={false}
        narrow
        backButton={tabIndex > 0}
        forwardButton={tabIndex < 1}
        goBack={() => this.handleTabChange(tabIndex - 1)}
        goForward={() => this.handleTabChange(tabIndex + 1)}
      >
        <div
          className={`learn-more-store-modal ${
            fromAthlete ? "from-athlete" : ""
          }`}
        >
          <LearnMoreHeader
            program={editCycle}
            fromAthlete={fromAthlete}
            athlete={athlete}
          />
          <ToggleComponent
            handleToggle={this.handleTabChange}
            tabIndex={tabIndex}
            editCycle={editCycle}
            fromAthlete={fromAthlete}
            athlete={athlete}
            program={editCycle}
          />
          <section>
            {tabIndex === 0 ? (
              <>
                <h3>{editCycle.name}</h3>
                <p className="p2">{editCycle.description}</p>
                {editCycle.goals && editCycle.goals.length > 0 && (
                  <ul className="tags">
                    {editCycle.goals.map((tag, index) => (
                      <li key={`${index}-${tag.title}`}>
                        <span>{tag.title}</span>
                      </li>
                    ))}
                  </ul>
                )}
                <OverviewComponent program={editCycle} />
              </>
            ) : (
              <BlocksComponent
                program={editCycle}
                programExercises={programExercises}
              />
            )}
          </section>
        </div>
      </Modal>
    );
  }
}

LearnMoreModal.contextType = RillContext;

export default LearnMoreModal;
